import React, { Component } from 'react';
import { Container, Header, Segment} from 'semantic-ui-react';
import AddReleaseModal from './AddRelease';
import * as api from '../../api';
import {AuthService} from "../../services/auth-service";

class AboutPage extends Component {
  constructor(props) {
    super(props);

    this.authServices = new AuthService();


    this.state = {
      isAdmin: false, // Default to false until the check is complete
      releases: [],
    };
  }

  componentDidMount() {
    api.getReleases()
      .then(res => {
        this.setState({
          releases: res
        });
      })
      .catch(err => {
      });


              // Check if the user is an admin
              this.checkAdminStatus();
  }



  checkAdminStatus = async () => {
    const isAdmin = await this.authServices.isUserAdmin();
    this.setState({ isAdmin });
};


  refreshReleases = () => {
    api.getReleases()
      .then(res => {
        this.setState({
          releases: res
        });
      })
      .catch(err => {
      });
  }

  render() {
    const { releases } = this.state;

    return (
      <Container fluid>
        {this.state.isAdmin && 
        <div>
          <h1>Release Manager</h1>
          <AddReleaseModal onNewRelease={this.refreshReleases}/>
                  </div>
  }
        <Header as='h2' attached='top'>
          Inenco Portal Version History
        </Header>
        {releases.map((release,index) => (
          <Segment key={index} attached>
            <div key={release.version}>
              <h3>Version: {release.version}</h3>
              <ul>

               
                { JSON.parse(release.features).map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>
          </Segment>
        ))}
      </Container>
    );
  }
}

export default AboutPage;
